import { lazy } from "react";
import AllPaySlips from "./AllPaySlips";
import MonthlyPayslips from "./MonthlyPayslips";

const ManageHoliday = lazy(() => import("./ManageHoliday"));
const ManageLeave = lazy(() => import("./ManageLeave"));
const LeaveManager = lazy(() => import("./LeaveManager"));

const hrcal = [
  {
    path: "/HRCal/Manage Holiday",
    element: <ManageHoliday />,
  },
  {
    path: "/HRCal/Manage Leave",
    element: <ManageLeave />,
  },
  {
    path: "/HRCal/Leave Manager",
    element: <LeaveManager />,
  },
  {
    path: "/pay-slips",
    element: <AllPaySlips />,
  },
  // {
  //   path: "/monthly-payslips",
  //   element: <MonthlyPayslips />,
  // },
];

export default hrcal;
